import React, { useState } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { PapiAttachmentFile } from '@wix/da-papi-types';
import { toMediaSrcFile } from '@wix/da-shared-react/pkg/utils/DeviationMediaService/helpers';
import ImagePreviewLayout from '../ImagePreviewLayout';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import cn from 'classnames';
import FakeFilmThumb from '../ImagePreview/FakeFilmThumb';
import AttachmentMediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService/AttachmentMediaService';

import s from './AttachmentPreview.scss';

export interface Props {
  className?: string;
  attachment: PapiAttachmentFile;
  width?: number | string;
  height?: number | string;
  objectFit?: 'contain' | 'cover';
}

const AttachmentPreview: React.FC<Props> = ({
  className,
  attachment,
  width,
  height,
  objectFit,
}) => {
  const [loaded, setLoaded] = useState(false);
  const isMultiVideo = useFlag('multi_video');

  const selectedMediaType =
    attachment.media.types.find(mt => mt.t === 'preview' || mt.t === 'fullview') ||
    attachment.media.types[0];
  const thumbData = toMediaSrcFile(attachment, selectedMediaType);

  if (
    isMultiVideo &&
    AttachmentMediaService.isVideoAttachment(attachment) &&
    (!thumbData || thumbData.isDefault)
  ) {
    return (
      <ImagePreviewLayout className={className}>
        <FakeFilmThumb />
      </ImagePreviewLayout>
    );
  }

  if (!thumbData) {
    return null;
  }

  return (
    <ImagePreviewLayout className={className}>
      {!loaded && <LoadingIndicator className={s['loader']} />}
      <img
        className={cn(s['image'], loaded && s['loaded'])}
        style={{
          objectFit,
        }}
        src={thumbData.src}
        alt={attachment.filename}
        width={width}
        height={height}
        onLoad={() => {
          setLoaded(true);
        }}
      />
    </ImagePreviewLayout>
  );
};
AttachmentPreview.displayName = 'AttachmentPreview';

export default AttachmentPreview;
